import { Component, OnInit } from '@angular/core';
import { Router } from '@angular/router';
import { Store } from '@ngrx/store';
import { TranslateService } from '@ngx-translate/core';
import { Observable, map, take } from 'rxjs';

import { selectSessionLanguage, selectSessionUser } from 'src/app/auth/store/session/session.selectors';
import { User } from '../../../core/models/user.model';
import { UIActions } from '../../../core/store/ui/ui.actions';
import { Language } from '../../../core/models/language.model';
import { selectUILanguageList } from '../../../core/store/ui/ui.selectors';
import { UserSettingsActions } from 'src/app/user-account/store/user-settings/user-settings.actions';

@Component({
  selector: 'app-header',
  templateUrl: './header.component.html',
  styleUrls: ['./header.component.scss'],
  standalone: false
})
export class HeaderComponent implements OnInit {
  selectedLanguage$: Observable<string>;
  user$: Observable<User>;
  languageList$: Observable<Language[]>;
  baseUrl = window.location.origin;

  constructor(private router: Router, private translateService: TranslateService, private store: Store) {
    this.selectedLanguage$ = this.store.select(selectSessionLanguage);
    this.user$ = this.store.select(selectSessionUser);
    this.languageList$ = this.store.select(selectUILanguageList);
  }

  ngOnInit(): void {
    // TODO: language list is requested, but not used. It will be used, when more than 3 languages in the app.
    this.store.dispatch(UIActions.get_language_list_start());
    this.selectedLanguage$
      .pipe(
        map(language => {
          this.translateService.use(language);
        })
      )
      .subscribe();
  }

  onLanguageChange(event) {
    this.user$
      .pipe(
        take(1),
        map(user => {
          if (user !== null) {
            this.store.dispatch(UserSettingsActions.set_user_language_start({ languageCode: event }));
          }
          this.translateService.use(event);
        })
      )
      .subscribe();
  }

  onLogout() {
    this.router.navigate(['/logout']);
  }
}
